<template>
    <v-container>
        <v-col :xs="12" :lg="10">
            <v-card>
                <v-card-title>Warehouses
                    <v-col class="d-flex justify-end">
                        <v-card-actions>
                            <v-btn color="secondary" small @click="redirectToAddNewWarehouse">Add warehouse</v-btn>
                        </v-card-actions>
                    </v-col>
                </v-card-title>


                <v-card-text>
                    <v-data-table
                            :headers="headers"
                            :items="items"
                            :options.sync="options"
                            :server-items-length="totalItems"
                            :loading="loading"
                            :footer-props="footerProps"
                            :dense="dense"
                            class="elevation-1"
                    >
                        <template v-slot:item.editButton="{ item }">
                            <v-btn :to="{name: 'warehouse-details', params: {id: item.id}}" color="secondary" x-small>Edit</v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-col>
    </v-container>
</template>

<script>
  const axios = require('axios')

  export default {
    name: "ItemsList",
    data() {
      return {
        footerProps: {
          "itemsPerPageOptions": [25, 50, 100]
        },
        dense: true,
        totalItems: 0,
        items: [],
        loading: true,
        options: {},
        headers: [
          {text: 'ID', value: 'id'},
          {text: 'Name', value: 'name'},
          {text: 'Peoplevox name', value: 'whm_name'},
          {text: 'Edit', value: 'editButton', sortable: false}
        ],
      }
    },
    watch: {
      options: {
        handler() {
          this.getItemsFromApi()
            .then(data => {
              this.loading = false
              this.items = data.items
              this.totalItems = data.total
            })
        },
        deep: true,
      },
    },
    methods: {
      getItemsFromApi() {
        this.loading = true
        return new Promise((resolve) => {
            //const {sortBy, sortDesc, page, itemsPerPage} = this.options
            var redirectToLoginFunction = this.redirectToLogin
            var limit = this.options.itemsPerPage
            var offset = (this.options.page - 1) * this.options.itemsPerPage

            axios.get("/api/warehouses/", {
              params: {
                limit: limit,
                offset: offset
              },
              headers: {
                Authorization: "Token " + this.$store.getters.authToken
              }
            }).then(function (response) {
              var total = response.data.count
              var items = response.data.results
              resolve({
                  items,
                  total,
                }
              )
            }).catch(function (error) {
              if (403 === error.response.status) {
                alert("Failed to obtain data")
                redirectToLoginFunction()
              }
            })
          }
        )
      },
      redirectToLogin() {
        this.$router.push({name: 'login'})
      },
      redirectToAddNewWarehouse(){
        this.$router.push({name: 'add-warehouse'})
      }
    },
  }
</script>

<style scoped>

</style>